import { FEATURE_FLAGS } from '@teamworksdev/influencer/core';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/gallery/:gallerySlug',
		name: 'PublicUploadPortal',
		component: () => import('@/views/PublicUploadPortal.vue'),
		props: true,
		meta: {
			requiresAuth: false,
			layout: 'LayoutDefault',
			requiredLDFlags: [FEATURE_FLAGS.GALLERY_PUBLIC_UPLOAD_PORTAL],
		},
	},
];

export default routes;
